import { Component } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';

declare var MediaRecorder: any;

/**
 * Generated class for the VideoCaptureComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'video-capture',
  templateUrl: 'video-capture.html'
})
export class VideoCaptureComponent {

  text: string;
  recorder;
  chunks;
  stream;

  constructor(public events: Events, private toastCtrl: ToastController) {
  }


  recordVideo() {
    this.chunks = [];
    navigator.mediaDevices.enumerateDevices().then(devices => {
      try {
        let camera;
        let videoDevices = devices.filter(device => device.kind === "videoinput");
        if (videoDevices.length == 0) {
          throw "Konnte keine Kamera finden!";
        }
        console.log(videoDevices);
        let backfacingCameras = videoDevices.filter(device => device.label.includes('facing back'));
        if (backfacingCameras.length == 0) {
          console.log('found no backfacing');
          camera = videoDevices[0];
        } else {
          console.log('found backfacing!');
          camera = backfacingCameras[0];
        }

        navigator.mediaDevices.getUserMedia({ video: { deviceId: camera.deviceId }, audio: true }).then(_stream => {
          console.log('got media');
          this.stream = _stream;
          document.querySelector("video").srcObject = this.stream;
          document.querySelector("video").muted = true;
          this.recorder = new MediaRecorder(this.stream, { mimeType: 'video/webm' });
          this.recorder.ondataavailable = e => {
            console.log(e);
            this.chunks.push(e.data);
            this.saveRecording();
          }
          this.recorder.start();
          console.log('started recording');
          document.getElementById('btnStartRecVid').hidden = true;
          document.getElementById("btnStopRecVid").hidden = false;
        }).catch(err => {
          let toast = this.toastCtrl.create({
            message: "Es gab einen Fehler beim aufzeichnen! " + err,
            duration: 5000,
            position: 'bottom'
          });
          toast.present();
          console.error("Es gab einen Fehler beim aufzeichnen! " + err);
        });

      } catch (err) {
        let toast = this.toastCtrl.create({
          message: "Es gab einen Fehler beim aufzeichnen! " + err,
          duration: 5000,
          position: 'bottom'
        });
        toast.present();
        console.error("Es gab einen Fehler beim aufzeichnen! " + err);
      }
    }).catch(err => {
      let toast = this.toastCtrl.create({
        message: "Es gab einen Fehler beim aufzeichnen! " + err,
        duration: 5000,
        position: 'bottom'
      });
      toast.present();
      console.error("Es gab einen Fehler beim aufzeichnen! " + err);
    });
  }

  saveRecording() {
    let blob = new Blob(this.chunks, { type: 'video/webm' })
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      var base64data = reader.result;
      document.getElementById("btnStartRecVid").hidden = false;
      document.getElementById('btnStopRecVid').hidden = true;
      document.querySelector("video").srcObject = null;
      document.querySelector("video").muted = false;
      document.querySelector("video").src = base64data.toString();
      //document.getElementById('videoPlayer').setAttribute("src", base64data.toString());
      this.events.publish('videocaptured', base64data.toString());
    }
    this.stopVideoMediaDevice();
  }

  stopRecordVideo() {
    this.recorder.stop();
  }

  stopVideoMediaDevice() {
    this.stream.getTracks().forEach(function (track) {
      if (track.readyState == 'live' && (track.kind === 'video' || track.kind === 'audio')) {
        track.stop();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/video-capture/video-capture.ts